const normalizeLineBreaks = (value) =>
  value
    .replace(/\r\n|\n\r/g, '\n')
    .replace(/\r/g, '\n')
    .replace(/\\r\\n|\\n\\r/gi, '\n')
    .replace(/\\r|\\n/gi, '\n')
    .replace(/\/r\/n|\/n\/r/gi, '\n')

const normalizeHtml = (value) => {
  if (typeof DOMParser === 'undefined' || !/<[a-z][^>]*>/i.test(value)) {
    return value
  }

  const document = new DOMParser().parseFromString(value, 'text/html')
  document.querySelectorAll('script, style').forEach((node) => node.remove())
  document.querySelectorAll('br').forEach((node) => node.replaceWith('\n'))
  document.querySelectorAll('p, div, li, tr, h1, h2, h3, h4, h5, h6').forEach((node) => node.append('\n'))
  return document.body.textContent || ''
}

const isTimeColon = (value, colonIndex) => {
  const before = value.slice(Math.max(0, colonIndex - 2), colonIndex)
  const after = value.slice(colonIndex + 1, colonIndex + 3)
  return /^\d{1,2}$/.test(before) && /^\d{2}$/.test(after)
}

export const getOrderDetailLineParts = (line) => {
  const text = line.trim()
  const colonIndex = text.search(/[:：]/)
  const hasFieldSeparator = colonIndex > 0 && colonIndex <= 40 && !isTimeColon(text, colonIndex) && text[colonIndex + 1] !== '/'

  if (!hasFieldSeparator) {
    return {
      key: '',
      value: text,
      isSection: false,
    }
  }

  const key = text.slice(0, colonIndex).trim()
  const value = text.slice(colonIndex + 1).trim()

  return {
    key: `${key}:`,
    value,
    isSection: !value,
  }
}

export const parseOrderDetailToLines = (orderDetail) => {
  if (typeof orderDetail !== 'string' || !orderDetail.trim()) {
    return []
  }

  const normalized = normalizeLineBreaks(normalizeHtml(orderDetail))
  const lines = []

  normalized.split('\n').forEach((line) => {
    const text = line.replace(/\u00a0/g, ' ').trim()
    if (!text) {
      if (lines.length > 0 && lines[lines.length - 1] !== '') {
        lines.push('')
      }
      return
    }
    lines.push(text)
  })

  return lines[lines.length - 1] === '' ? lines.slice(0, -1) : lines
}
